<template>
    <Button :label="$t(appointmentLabel)" icon="pi pi-calendar" class="p-button-info p-button-sm mr-2" @click="onShowAppointmentModal" />

    <CustomSidebar v-model:visible="showAppointmentModal" position="bottom" :dismissable="false" :title="$t(appointmentLabel)" class="p-1" :blocked="blocked">
        <template #actions>
            <Button icon="pi pi-calendar" class="p-button p-info-success mr-1" :label="$t(appointmentLabel)" @click="save()"></Button>
        </template>

        <div class="flex" style="width:calc(100% - 2rem)">
            <div class="col-5 md-5 p-fluid">
                <ScrollPanel style="width:100%;height:80vh">
                    <ModalDataShipment :data="shipmentData" v-if="shipmentData"/>
                </ScrollPanel>
            </div>
            <Divider layout="vertical" />
            <div class="col-7 md-7 p-fluid">
                <ScrollPanel style="width:100%;height: 80vh">
                    <DataTable :loading="!shipmentData" :value="shipmentData ? shipmentData.Details : null" responsiveLayout="scroll" class="p-datatable-sm editable-cells-table">
                        <Column field="Item_No" :header="$t('item_no')" key="Item_No" style="width:10%">  
                        </Column>
                        <Column field="Material_Name" :header="$t('material_name')" key="Material_Name">
                        </Column>
                        <Column field="Qty" :header="$t('qty')" key="Active" style="width:15%">
                            <template #body="slotProps">
                                {{$formatNumber(slotProps.data[slotProps.column.props.field])}}
                            </template>
                        </Column>
                        <Column field="UOM" header="UOM" key="Active" style="width:10%">
                        </Column>
                    </DataTable>

                    <Divider />
                    
                    <div class="fluid">
                        <div class="field grid">
                            <div class="col-12">
                                <FormField labelClass="col-5" fieldClass="col-7" fieldName="Appoointment_Date" :labelName="$t('appointment_date')" v-model="appointmentModel" >
                                <DatePicker 
                                    :placeholder="$t('created_date')" 
                                    dateFormat="dd/mm/yyyy" 
                                    inputMask="99/99/9999" 
                                    momentFormat="DD/MM/YYYY" 
                                    class="p-inputtext-sm" 
                                    v-model="appointmentModel.appointment_date" 
                                    selectionMode="single" 
                                    v-if="appointmentModel" 
                                    :minDate="minDate"
                                    :maxDate="maxDate"
                                    @update:modelValue="getScheduleData"
                                />
                            </FormField>

                            <FormField labelClass="col-5" fieldClass="col-7" fieldName="Warehouse_Code" :labelName="$t('warehouse')" v-model="appointmentModel">
                                <CustomSelect 
                                    class="p-inputtext-sm" 
                                    v-model="appointmentModel.warehouse_code" 
                                    :url="this.$API_URL + 'list/shipment_warehouse'" 
                                    :minLength="0" 
                                    :params="{ shipment_id: shipmentData.Id }" 
                                    v-if="appointmentModel" 
                                    :initFirst="true"
                                    />
                            </FormField>

                            <FormField labelClass="col-5" fieldClass="col-7" fieldName="Product_Category" :labelName="$t('product_category')" v-model="appointmentModel">
                                <CustomSelect 
                                    class="p-inputtext-sm" 
                                    v-model="appointmentModel.business_segment_id" 
                                    :url="this.$API_URL + 'list/shipment_business_segment'" 
                                    :minLength="0" 
                                    :params="{ shipment_id: shipmentData.Id, warehouse_code: appointmentModel.warehouse_code, appointment_date: $formatDate(appointmentModel.appointment_date)   }" 
                                    v-if="appointmentModel" 
                                    @change="getScheduleData"
                                    :initFirst="true"
                                    />
                            </FormField>
                            </div>
                            
                        </div>
                        <DataTable 
                                :loading="loadScheduleData"  
                                v-model:selection="selectedSchedule" 
                                :value="scheduleData ? scheduleData : null" 
                                responsiveLayout="scroll" 
                                class="p-datatable-sm editable-cells-table"
                                :rowClass="rowDisabled"
                                >
                            <Column selectionMode="single" headerStyle="width: 3em">
                                <template #header>
                                    <Button icon="pi pi-refresh" class="p-button-rounded p-button-outlined" @click="getScheduleData"/>
                                </template>
                            </Column>
                            <Column field="Slot_Name" :header="$t('slot_name')" key="Slot_Name">  
                            </Column>
                            <Column field="Remaining_Slot" :header="$t('remaining_slot')">
                            </Column>
                            <Column field="Time_From" :header="$t('time_from')" key="Time_From">
                                <template #body="slotProps">
                                    {{$formatTime(slotProps.data[slotProps.column.props.field])}}
                                </template>
                            </Column>
                            <Column field="Time_To" :header="$t('time_to')" key="Time_From">
                                <template #body="slotProps">
                                    {{$formatTime(slotProps.data[slotProps.column.props.field])}}
                                </template>
                            </Column>
                            
                        </DataTable>
                    </div>
                </ScrollPanel>

                
                  
            </div>
        </div>
    </CustomSidebar>    
</template>
<script>
    import ModalDataShipment from '../Helper/_ModalDataShipment.vue'

    export default{
        components: {
            'ModalDataShipment': ModalDataShipment,
        },
        emits:['close'],
        props:{
            data: {
                type: Object,
                default: null
            },
            type:{
                type:String,
                default: ""
            }
        },
        data(){
            return{
                showAppointmentModal: false,
                shipmentData: null,
                appointmentModel:null,
                scheduleData: null,
                dataUrl: "shipment/",
                blocked:false,
                appointmentLabel:"create_appointment",
                selectedSchedule: null,
                loadScheduleData: false,
                minDate: null,
                maxDate:null
            }
        },
        mounted(){
            if(this.type == "create"){
                this.appointmentLabel = "create_appointment";
            }
            else if(this.type == "edit"){
                this.appointmentLabel = "edit_appointment";
            }   
        },
        methods:{
            reset(){
                this.shipmentData = null;
                this.appointmentModel = null;
            },
            onShowAppointmentModal(){
                this.reset();
            
                this.blocked = true;
                this.showAppointmentModal = true;

                var self = this;

                this.$axios.get(this.$API_URL + this.dataUrl + this.data.Id + "/" + this.$FORM_MODE_EDIT)
                    .then((response) => {
                        if (response.data.success) {
                            self.shipmentData = response.data.data.header;
                            self.appointmentModel = response.data.data.appointment;

                            self.minDate = new Date(self.shipmentData.Stuffing_Date_From);
                            self.maxDate = new Date(self.shipmentData.Stuffing_Date_To);

                            self.appointmentModel.appointment_date = new Date(self.shipmentData.Stuffing_Date_From);
                            self.appointmentModel.warehouse_code = self.shipmentData.default_warehouse_code;
                            self.appointmentModel.business_segment_id = self.shipmentData.default_business_segment_id;

                            if(self.appointmentModel.warehouse_code && self.appointmentModel.business_segment_id)
                            {
                                self.getScheduleData();
                            }
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            //self.showAssignModal = false;
                        }
                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });
            },
            save(){
                var self = this;

                if(this.selectedSchedule == null){
                    self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: this.$t('alert.require_slot'), life: 120000});
                    return;
                }

                this.blocked = true;

                this.appointmentModel.shipment_id = this.data.Id;
                this.appointmentModel.appointment_matrix_schedule_id = this.selectedSchedule.Id;

                this.$axios.post(this.$API_URL + this.dataUrl + "appointment", this.appointmentModel)
                    .then((response) => {
                        if (response.data.success) {
                            self.showAppointmentModal = false;
                            self.$parent.$toast.add({ severity: 'success', summary: "Data Saved", detail: response.data.message, life: 120000 });
                            self.$emit('close');
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }

                        self.blocked = false;
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });

            },
            getScheduleData(){
                this.blocked = true;

                this.scheduleData = null;
            
                var data = {
                    appointment_date: this.appointmentModel.appointment_date,
                    warehouse_code: this.appointmentModel.warehouse_code,
                    business_segment_id: this.appointmentModel.business_segment_id
                };

                var self = this;

                this.$axios.post(this.$API_URL + "list/appointment_slot", data)
                    .then((response) => {
                        if (response.data.success) {
                            self.scheduleData = response.data.data;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }

                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        //self.showAssignModal = false;
                    });
            },
            rowDisabled(data){
                return data.disabled ? "appointment-slot-disabled" : "";
            }
            // addDetail() {
            //     var newDetail = this.driverModel;
            //     newDetail.mode = this.$FORM_MODE_CREATE;
            //     var det = { ...newDetail };

            //     this.driverModels.push(det);
            // },
            // deleteDetail(event) {
            //     if (event) {
            //         var detail = this.driverModels[event.index];

            //         if (detail.mode == this.$FORM_MODE_CREATE) this.driverModels.splice(this.driverModels.indexOf(detail), 1);
            //         else detail.mode = this.$FORM_MODE_DELETE;
            //     }
            // },
        },
        computed:{
            assignEditDriverModel(){
                return {driverModel: this.driverModel, driverModels: this.driverModels};
            }
        }
    }

</script>

